import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CourseRoutingModule} from './course-routing.module';
import {CourseComponent} from './course.component';
import {AddCourseFormComponent} from './add-course/add-course.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
    declarations: [CourseComponent, AddCourseFormComponent],
    imports: [
        CommonModule,
        CourseRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ],
    exports: [CourseComponent, AddCourseFormComponent]
})
export class CourseModule {
}
